// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23 1H1V23H23V1ZM3.45301 10.9873V12.4958L10.6185 15.8062V13.9467L5.58485 11.7872V11.6959L10.6185 9.5364V7.67694L3.45301 10.9873ZM13.3776 15.8062L20.5431 12.4958V10.9873L13.3776 7.67694V9.5364L18.4112 11.6959V11.7872L13.3776 13.9467V15.8062Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
